import pubsub from "@viewlift/pubsub";
import PackageJson from '../../package.json';
import playerPackageJson from '@viewlift/player/package.json';
import { getStorageItem } from "../helpers/storageManager";
import { VISITOR } from "./Configuration";
const playerVersion = playerPackageJson.version
const version = PackageJson.version
var Media
let loadMap = new Map()
let adPayload = null
let adBeforeSessionStarted = false
export let VideoAnalyticsProviderWrapper
export const isAnalyticsSessionRunning = (function () {
  let isSessionRunning = false;
  return {
    get: () => isSessionRunning,
    set: (value) => {
      isSessionRunning = value;
    },
    getVideoId: () => loadMap.entries().next().value?.[0]
  };
})();


(function () {

  function VideoAnalyticsProvider(player, mediaInstance,entitlementData) {
    Media = mediaInstance
    if (!player) {
      throw new Error("Player reference cannot be null.")
    }
    //Constructor
    this._player = player;
    this._adComplete = false;
    this._entitlementData = entitlementData
    this._stopPlayheadUpdate = false
    this._mediaTracker = Media.getInstance();
    this._isSeekComplete = true;
    this._isChapterStart = false
    this._isBufferComplete = true
    this.isWaiting = false
    this._isSessionStarted = false
    this.lastUpdateTime = null
    this.isAutoPlayed = false
    this.videotmsid = null
    this.programmeDuration = 86400
    this.programmeStartTime = 0
    this.lcProgrammeName = null
    this.preAdRollPlayed = false
    this.lcSubTitle = null
    this._breakStartPlayhead = 0
    this._playheadInterval = null
    this._chapterStartInterval = null
    this._chapterIndex = 0
    this._isSeries = entitlementData?.mediaType === "EPISODIC" || false
    this._isLiveStream = entitlementData?.streamingInfo?.isLiveStream || false
    this.isLinearStream = this._isLiveStream && entitlementData?.contentType === "LINEARCHANNEL"
    if(!this?._mediaTracker) return

    this._installEventListeners();
  }

  function secondsWithinDay(streamSeconds) {
    if (!isFinite(streamSeconds)) return 0;
    const DAY = 86400;
    const rem = ((streamSeconds % DAY) + DAY) % DAY;
    return rem;
  }

  function isPreRollAd() {
    let adsQueueList = window?.adsQueueList || []
    if(adsQueueList.length && adsQueueList[0]?.startTimeInSeconds === 0 && adsQueueList[0]?.ads.length) {
      return true
    } else {
      return false
    }
  }
  
function getProgrammeElapsedSeconds() {
  let startTime = window?.lcProgrammeDetails?.programmeStartTime || "";
  const startDate = new Date(startTime);
  let now = Date.now();
  return Math.floor((now - startDate.getTime()) / 1000);
}

  function calculateChapterLength(chapterIndex, entitlementData) {
    let adsQueueList = window?.adsQueueList || []
    if(!adsQueueList?.length) return entitlementData?.runtime || window?.lcProgrammeDetails?.programDuration || 0
    let previousChapter = adsQueueList[chapterIndex - 1]
    let startingPoint = previousChapter?.startTimeInSeconds + previousChapter?.durationInSeconds
    let chapteroffset =  adsQueueList[chapterIndex]?.startTimeInSeconds
    return chapteroffset ? (chapteroffset - startingPoint) : 0
  }
function getContentTime(currentTime) {
  const adPods = window?.adsQueueList || [];
  if (!Array.isArray(adPods) || !adPods.length) return currentTime;

  let adTime = 0;

  for (const pod of adPods) {
    const start = pod.startTimeInSeconds;
    const end = start + (pod.durationInSeconds || 0);

    if (currentTime >= end) {
      adTime += pod.durationInSeconds || 0;
    }
  }

  return currentTime - adTime;
}


  VideoAnalyticsProvider.prototype.destroy = function (isComplete = false) {
    if (this._mediaTracker) {
      if(!isComplete) this._onUnload(); 
      this._mediaTracker = null;
    }

    if (this._player) {
      this._player = null;
      this._uninstallEventListeners();
    }
  };

  VideoAnalyticsProvider.prototype._onLoad = function (payload) {
    if(!this?._mediaTracker) return
    if (this.preAdRollPlayed) return
    var videoInfo = this._entitlementData
    const isLiveStream = videoInfo?.streamingInfo?.isLiveStream || false
    const isLiveGame = videoInfo?.isGame && isLiveStream || false
    if(!this.isLinearStream) {
      if(loadMap.has(this._entitlementData?.gist?.id) && !this._entitlementData?.replay) return 
      else {
        loadMap.clear()
        loadMap.set(this._entitlementData?.gist?.id,true)
      }
    }else {
      if(loadMap.has(window.lcProgrammeDetails.videotmsid)) return
      else {
        loadMap.clear()
        loadMap.set(window.lcProgrammeDetails.videotmsid,true)
        this.videotmsid = loadMap.entries().next().value[0]
        this.lcProgrammeName = window?.lcProgrammeDetails?.lcProgrammeName
        this.lcSubTitle = window?.lcProgrammeDetails?.lcSubTitle
        this.programmeDuration = window?.lcProgrammeDetails?.programDuration
      }
    }
    let streamType = "fullEpisodePlayer"
    if(!this._isSeries) {
      streamType = "movie"
    }
    if(this.isLinearStream) { 
      streamType = "Linear"
      this.programmeStartTime = getProgrammeElapsedSeconds()
    }
    let runtime = this.isLinearStream ? this.programmeDuration : isLiveStream ? 86400 : videoInfo.runtime
    if(isLiveGame) {
      runtime = videoInfo?.scheduleGameRuntime
      streamType = "sle"
    }
    var mediaInfo = Media.createMediaObject(!this.isLinearStream ? videoInfo.gist.title : this.lcProgrammeName,!this.isLinearStream ? videoInfo.gist.id : this.videotmsid, runtime, streamType, Media.MediaType.Video);
    mediaInfo[Media.MediaObjectKey.GranularAdTracking] = true;
    if(this._entitlementData?.watchedTimeHistory > 10) {
      mediaInfo[Media.MediaObjectKey.MediaResumed] = true;
    }
    let data = this._formulatePayload({type: "VIDEO_LOAD", info : {}})
    data[Media.VideoMetadataKeys.Show] = this.lcProgrammeName || this._entitlementData?.series?.title || videoInfo.gist.title
    data[Media.VideoMetadataKeys.Episode] = !this.isLinearStream ? !this._isSeries ? "N/A" : videoInfo.gist.title : this.lcSubTitle || "N/A"
    if(this._entitlementData?.replay && this._isSessionStarted) return
    if(this._isSessionStarted) {
      this._onUnload()
    }
    this._mediaTracker.trackSessionStart(mediaInfo,data);
    this._isSessionStarted = true
    isAnalyticsSessionRunning.set(true)
    this._onPlayheadUpdate()
    this._onPlay()
    if(adBeforeSessionStarted) {
      console.log("ad already started before session started", adPayload)
      this._onBreakStart(adPayload)
    }
    if (!this?._isChapterStart) {
      this._chapterStartInterval = setInterval(() => {
          if(window?.adsQueueList?.length) {
          if(!isPreRollAd()) {
            clearInterval(this._chapterStartInterval)
              this._onChapterStart()
              this._isChapterStart = true
          }
        }else {
          setTimeout(() => {
            clearInterval(this._chapterStartInterval)
            if(!this?._isChapterStart) {
            this._onChapterStart()
            this._isChapterStart = true
            }
          }, 1000)
        }
        }, 1000)
    }
  };

  VideoAnalyticsProvider.prototype._onUnload = function () {
    if(!this?._mediaTracker) return
    this._chapterIndex = 0
    this._isSessionStarted = false
    isAnalyticsSessionRunning.set(false)
    this._isChapterStart = false
    this.preAdRollPlayed = false
    this.programmeStartTime = 0
    adBeforeSessionStarted = false
    this._mediaTracker.trackSessionEnd();
    // loadMap.clear()
  };
  let onPlayDebounce = null
  VideoAnalyticsProvider.prototype._onPlay = function () {
    if (!this?._mediaTracker) return
    if (!this._isSessionStarted) return
    if(this._isLiveStream) {
      this.programmeStartTime = getProgrammeElapsedSeconds()
    }
    clearTimeout(onPlayDebounce)
    onPlayDebounce = setTimeout(() => {
      if(!this._isBufferComplete) {
        this._isBufferComplete = true
      }
      this._mediaTracker.trackPlay();
    }, 0)
  }
  VideoAnalyticsProvider.prototype._onPause = function () {
    if(!this?._mediaTracker) return
    if(!this._isSessionStarted) return
    if(!this._isChapterStart) {
      clearInterval(this._playheadInterval)
    }
     if(!this._isBufferComplete) {
       this._mediaTracker.trackPlay();
      }
    this._mediaTracker.trackPause();
  };

  VideoAnalyticsProvider.prototype._onSeekStart = function () {
    if(!this?._mediaTracker) return
    if(!this._isSessionStarted) return
    this._isSeekComplete = false
    this._mediaTracker.trackEvent(Media.Event.SeekStart, null, null);
  };

  VideoAnalyticsProvider.prototype._onSeekComplete = function () {
    if(!this?._mediaTracker) return
    if(!this._isSessionStarted) return
    if(this._isSeekComplete) return
    this._mediaTracker.trackEvent(Media.Event.SeekComplete, null, null);
    this._isSeekComplete = true
  };

  VideoAnalyticsProvider.prototype._onBufferStart = function () {
    if(!this?._mediaTracker) return
    if(!this._isSessionStarted) return
    // buffer needs to be called after seek
    if(!this._isSeekComplete) {
      this._onSeekComplete()
    }
      this.Waiting()
      this._isBufferComplete = false
      this._mediaTracker.trackEvent(Media.Event.BufferStart, null, null);
};

  VideoAnalyticsProvider.prototype._onBreakStart = function (data) {
    adPayload = data
    console.log("Break Start : ","_mediaTracker ", this?._mediaTracker," _isSessionStarted ", this._isSessionStarted," preAdRollPlayed ", this.preAdRollPlayed, " adPayload ",adPayload)
    if(!this._isSessionStarted && !adBeforeSessionStarted) {
      adBeforeSessionStarted = true
      console.log("adBeforeSessionStarted",adBeforeSessionStarted)
    }
    if(!this?._mediaTracker) return
    adBeforeSessionStarted = false
    if(this?._isChapterStart) {
      this._onChapterComplete()
      this._isChapterStart = false
    }
    if(!this._isSessionStarted && !this.preAdRollPlayed) {
      this._onLoad()
      this.preAdRollPlayed = true
    }
    if(!this?._isChapterStart) {
      this._stopPlayheadUpdate = true
    }
    const { startTimeInSeconds: rawStartTime, ad, adIndex } = data?.adsData;
    const startTimeInSeconds = Math.round(rawStartTime)
    const position = adIndex + 1 || 1
    
    var _adBreakInfo = ad
    if(!_adBreakInfo) return
    var adBreakInfo = Media.createAdBreakObject(_adBreakInfo?.adTitle, position, startTimeInSeconds);
  
      var _adInfo = _adBreakInfo
      var resolver = _adInfo?.adSystem
      var creativeId = _adInfo?.creativeId
      let adContextData = this._formulatePayload({type: "AD", info : _adInfo})
      adContextData["resolver"] = resolver || "N/A"
      adContextData["creative"] = creativeId || "N/A"
      adContextData["advertiser"] = "N/A"
      adContextData["creativeName"] = "N/A"

    this._mediaTracker.trackEvent(Media.Event.AdBreakStart, adBreakInfo);
    console.log("clearing adPayload")
    adPayload = null
  };

  VideoAnalyticsProvider.prototype._onAdStart = function (data) {
    console.log("Ad Start : ","_mediaTracker ", this?._mediaTracker," _isSessionStarted ", this._isSessionStarted," preAdRollPlayed ", this.preAdRollPlayed)
    if(!this?._mediaTracker) return
    if(this.preAdRollPlayed) {
      this.preAdRollPlayed = false
    }
    this._adComplete = false
    const { startTimeInSeconds: rawStartTime, ad, adIndex } = data?.adsData;
    const startTimeInSeconds = Math.round(rawStartTime);
    
    var _adBreakInfo = ad
    if(!_adBreakInfo) return
      // var adBreakInfo = Media.createAdBreakObject(_adBreakInfo?.adTitle, startTimeInSeconds, startTimeInSeconds);
  
      var _adInfo = _adBreakInfo
      var resolver = _adInfo?.adSystem
      var creativeId = _adInfo?.creativeId
      var adInfo = Media.createAdObject(_adInfo?.adTitle, _adInfo?.adId, startTimeInSeconds,_adInfo?.durationInSeconds);
      let adContextData = this._formulatePayload({type: "AD", info : _adInfo})
      adContextData["resolver"] = resolver || "N/A"
      adContextData["creative"] = creativeId || "N/A"
      adContextData["advertiser"] = "N/A"
      adContextData["creativeName"] = "N/A"

    // this._mediaTracker.trackEvent(Media.Event.AdBreakStart, adBreakInfo);
    this._mediaTracker.trackEvent(Media.Event.AdStart, adInfo, adContextData);
  };

  VideoAnalyticsProvider.prototype._onAdComplete = function () {
    if(!this?._mediaTracker) return
    if(!this._adComplete) {
      this._mediaTracker.trackEvent(Media.Event.AdComplete);
      this._adComplete = true
    }
  };

  VideoAnalyticsProvider.prototype._onBreakComplete = function() {
    if(!this?._mediaTracker) return
    this._stopPlayheadUpdate = false
    this._onAdComplete()
    this._mediaTracker.trackEvent(Media.Event.AdBreakComplete);
    clearInterval(this._playheadInterval)
    this._breakStartPlayhead = 0
    if(!this?._isChapterStart) {
      this._onChapterStart()
      this._isChapterStart = true
    }
  }

  VideoAnalyticsProvider.prototype._onChapterStart = function () {
    if(!this?._mediaTracker) return
     let currentTime = 0
    if(this?._player) {
      currentTime = this?._player?.currentTime() || 0
    }
    if(this?._isLiveStream) {
      currentTime = 0
    }
    this._chapterIndex += 1
    let chapterTitle = this._entitlementData?.gist?.title + ` - Chapter ${this._chapterIndex}`; 
    let chapterLength = calculateChapterLength(this._chapterIndex, this._entitlementData)
    var chapterInfo = Media.createChapterObject(chapterTitle, this._chapterIndex, chapterLength, currentTime);
    let chapterContextData = this._formulatePayload({type: "CHAPTER", info : chapterInfo})

    this._mediaTracker.trackEvent(Media.Event.ChapterStart, chapterInfo, chapterContextData);
  };

  VideoAnalyticsProvider.prototype._onChapterComplete = function () {
    if(!this?._mediaTracker) return
    this._mediaTracker.trackEvent(Media.Event.ChapterComplete);
  };

  VideoAnalyticsProvider.prototype._onComplete = function () {
    if(!this?._mediaTracker) return
    if (this?._isChapterStart) {
      this._onChapterComplete()
      this._isChapterStart = false
    }
    this._chapterIndex = 0
    this._mediaTracker.trackComplete();
    this.programmeStartTime = 0
    this._isSessionStarted = false
    isAnalyticsSessionRunning.set(false)
    if(!this._isLiveStream) {
      this.destroy(true)
    }
  };

  VideoAnalyticsProvider.prototype._onPlayheadUpdate = function () {
    if (!this?._mediaTracker) return
    if(!this._isSessionStarted) return
    if(this.isLinearStream) {
      this.programmeStartTime = getProgrammeElapsedSeconds()
      this.programmeStartTime = this.programmeStartTime + 1
      this._mediaTracker.updatePlayhead(this.programmeStartTime);
      return
    }
    if(this._isLiveStream) {
      let currentTime = secondsWithinDay(this._player.currentTime())
      this._mediaTracker.updatePlayhead(currentTime);
      return
    }
    if (!this._stopPlayheadUpdate) {
      const calculatedTime = getContentTime(this._player.currentTime());
      this._mediaTracker.updatePlayhead(calculatedTime);
      this._breakStartPlayhead = calculatedTime
    }else {
      this._mediaTracker.updatePlayhead(this._breakStartPlayhead);
    }
  }
  VideoAnalyticsProvider.prototype._onUpdateTrigger = function () {
    const now = Date.now();
    if(!this.lastUpdateTime) this.lastUpdateTime = now
    if (this.lastUpdateTime && (now - this.lastUpdateTime < 1000)) {
      return;
    }
    this.lastUpdateTime = now;

    if (!this.isAutoPlayed) {
      this.isAutoPlayed = true;
      this._onLoad();
    }

    const current = this._player?.currentTime();
    const total = this._player?.duration();
    if (!this._isLiveStream && total - current < 1) {
      this._onComplete()
    }

    this._onPlayheadUpdate();
  }

  VideoAnalyticsProvider.prototype._checkForAutoPlay = function (player,self) {
     player.ready(() => {
      const playPromise = player.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            if (!self.isAutoPlayed) {
              self.isAutoPlayed = true
              self._onLoad()
            }
          })
          .catch((err) => {
            self.isAutoPlayed = false
          })
      }
    });
  }

 VideoAnalyticsProvider.prototype.Waiting = function () {
  if(this.isWaiting) return;

  const bufferStop = () => {
    this.isWaiting = false;
    this._onPlay()
  };
  this.isWaiting = true;
  this._player.any(['playing', 'timeupdate'], bufferStop);
}

  VideoAnalyticsProvider.prototype._installEventListeners = function () {
    // Register as observers to various VideoPlayer events.
    const self = this
    let player = this._player
    player?.on("loadeddata", () => {
      this.isAutoPlayed = false
      this._checkForAutoPlay(player, this)
    })
    player?.on("play", () => this._onPlay())
    player?.on("pause", () => this._onPause())
    player?.on("seeking", () => this._onSeekStart())
    player?.on("seeked", () => this._onSeekComplete())
    player?.on("waiting", () => this._onBufferStart())
    player?.on('timeupdate', () => this._onUpdateTrigger());
    player?.on('ended', () => this._onComplete());
    if(window?.cast?.framework) {
      player?.on('chromecastConnected', () => {
        window.isCastDevice = true
      })
      player?.on('chromecastDisconnected', () => {
        window.isCastDevice = false
      })
    }
    (function listensAdverts() {
      pubsub.subscribe("ad-event-handler",(data) => {
        if(!data?.adsData?.ad) return
        switch (data?.adsData?.eventType) {
          case "breakStart":
            self._onBreakStart(data)
            break;
          case "firstQuartile":
            self._onAdStart(data)
            break;
          case "complete":
            self._onAdComplete()
            break;
          case "breakEnd":
            self?._onBreakComplete()
          default:
            //
        }
      })
      pubsub.subscribe('start-next-session',()=> {
        self._onLoad()
      })
      pubsub.subscribe('update-player-data',(data)=> {
        self._entitlementData = data
      })
      pubsub.subscribe("video-ends",() => {
      self._onComplete()
      })
      pubsub.subscribe("destroy-adobe-analytics-instance",() => {
      self?.destroy()
    })
    }())
};

VideoAnalyticsProvider.prototype._uninstallEventListeners = function () {
    // unregister as observers to various VideoPlayer events.
    const self = this
    let player = self._player
     player?.off("loadeddata", () => {
      this.isAutoPlayed = false
      this._checkForAutoPlay(player, this)
    })
    player?.off("play", () => self._onPlay())
    player?.off("pause", () => self._onPause())
    player?.off("seeking", () => self._onSeekStart())
    player?.off("seeked", () => self._onSeekComplete())
    player?.off("waiting", () => self._onBufferStart())
    player?.off('timeupdate', () => self._onUpdateTrigger(self))
    player?.off('ended', () => self._onComplete());
    // Listens to ads events
    (function listensAdverts() {
      pubsub.unsubscribe("ad-event-handler",(data) => {
        switch (data?.adsData?.eventType) {
          case "firstQuartile":
            self?._onAdStart(data)
            break;
          case "complete":
            self._onAdComplete()
            break;
          case "breakEnd":
            self?._onBreakComplete()
            break;
          default:
            //
        }
      })
    }())
      pubsub.unsubscribe("video-ends",() => {
      self._onComplete()
      })
      pubsub.unsubscribe('update-player-data',(data)=> {
        self._entitlementData = data
      })
      pubsub.unsubscribe('start-next-session',()=> {
        self.isAutoPlayed = true
        self._onLoad()
      })
      pubsub.unsubscribe("destroy-adobe-analytics-instance",() => {
      self?.destroy()
    })
};
function getTimeSegment(date) {
  const hour = date.getHours();

  if (hour >= 5 && hour < 12) {
    return "morning";
  } else if (hour >= 12 && hour < 17) {
    return "afternoon";
  } else if (hour >= 17 && hour < 22) {
    return "primetime";
  } else {
    return "latenight";
  }
}

function getStreamType(url) {
  if (!url || typeof url !== "string") return null;

  const lowerUrl = url.toLowerCase();

  if (lowerUrl.includes(".mpd")) {
    return "DASH";
  } else if (lowerUrl.includes(".m3u8")) {
    return "HLS";
  } else {
    return "MP4";
  }
}

function isMobileBrowser() {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function getPlatformType() {
  if (navigator.userAgentData) {
  navigator.userAgentData.getHighEntropyValues(['platform', 'model', 'mobile'])
    .then(ua => {
      if (ua.mobile) {
        return "Mobile";
      } else {
        return "PC";
      }
    });
}

if (isMobileBrowser()) {
  return "Mobile";
} else {
  return "PC";
}
}

function getFormattedData(ms) {
    const now = ms ? new Date(ms * 1000) : new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const min = now.getMinutes().toString().padStart(2, '0');
    const hrs = now.getHours().toString().padStart(2, '0');
    const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const day = dayNames[now.getDay()]
    return {date : `${month}/${dd}/${year}`, 
            day, 
            hrs, 
            min, 
            year,
            now};
}
  VideoAnalyticsProvider.prototype._formulatePayload = function (data) {
   
    const seriesTitle = this._entitlementData?.mediaType === "EPISODIC" ? this._entitlementData?.series?.title : null
    const isFullscreen = this._player?.isFullscreen() ? " FullScreen" : "Normal";
    const isLiveStream = this._entitlementData?.streamingInfo?.isLiveStream || false
    const {date,hrs,day,min,now } = getFormattedData()
    const programmingType = this._entitlementData?.metadata?.filter((keys) => keys?.name === "programmingType")?.map((program) => program?.value)
    let videolanguage = this._entitlementData?.gist?.languageCode
    const defaultLanguage = window?.app_data?.appcmsMain?.languages?.default?.code
    if(videolanguage === "default") {
      videolanguage = defaultLanguage
    }
    let monetizationModels = this._entitlementData?.monetizationModels?.map((plan) => plan?.type) || []
    var contextData = {
      "appVersion" : version,
      "videoapp": window?.app_data?.site?.siteInternalName,
      "playerVersion": playerVersion,
      "videoplatform" : "Web",
      "videoguid" : this._entitlementData?.gist?.id,
      "videoprogram" : seriesTitle || this._entitlementData?.gist?.title,
      "videotitle" : this._entitlementData?.gist?.title,
      "videoinitiate" : window?.videoinitiate || "Manual",
      "videodate" : date,
      "videoday" : day,
      "videohour" : `${hrs}:00`,
      "videominute" : min,
      "videoairdate" : getFormattedData(this._entitlementData?.publishDate).date,
      "videostatus" :  monetizationModels.includes("FREE") ? "Unrestricted" : "Restricted",
      "videoplayerurl" : window?.location?.href || "",
      "videodomain" : window?.location?.origin || "",
      "videocallsign" : "N/A",
      "videocliptype" : "N/A",
      "videoscreen" : isFullscreen,
      "videorequestorid": window?.app_data?.appcmsPlatform?.tveSettings?.requestorID,
      "videolanguage" : videolanguage || "N/A",
      "videodaypart" : getTimeSegment(now),
      "videoplayertech" : getStreamType(this._player.currentSrc()),
      "videoresearchtitle" : this._entitlementData?.videoresearchtitle || this._entitlementData?.gist?.title,
      "ovp" : getPlatformType(),
      "videobroadcast" : isLiveStream ? "Broadcast" : "Digital",
      "videocrossdevice" : window?.isCastDevice ? "T" : "F",
      "videosport" : this._entitlementData?.sportsName || "N/A",
      "videoleague" : this._entitlementData?.leagueName || "N/A",
      "videocliptype" : programmingType?.length ? programmingType[0] : "N/A",
      "videocastsource" : "N/A",
      "videosponsor" : "N/A",
      "publisher" : VISITOR.MARKETING_CLOUD_ORG_ID, //need clarrification,
    }
    if(this._entitlementData?.network || this._entitlementData?.seriesNetwork || this._entitlementData?.videoNetwork) {
      contextData["videonetwork"] = this._entitlementData?.network || this._entitlementData?.seriesNetwork || this._entitlementData?.videoNetwork
    }
    if(this._entitlementData?.contentType === "LINEARCHANNEL") {
      contextData["videoprogram"] = this.lcProgrammeName || window?.lcProgrammeName || this._entitlementData?.gist?.title
      contextData["videotitle"] = this.lcProgrammeName || window?.lcProgrammeName || this._entitlementData?.gist?.title
    }
    contextData[ADB.Media.VideoMetadataKeys.AssetId] = this._entitlementData?.gist?.id
    const AuthenticationStore = getStorageItem('AuthenticationStore')
    let userInfo = AuthenticationStore?.user
    if(userInfo?.tveMetadata?.mvpdProvider) {
      contextData["videomvpd"] = userInfo?.tveMetadata?.mvpdProvider
      contextData["videocallsign"] = userInfo?.tveMetadata?.mvpdProvider
      contextData["videopassguid"] = userInfo?.tveMetadata?.tveUserId
    }
    if(this._entitlementData?.videotmsid || window?.lcProgrammeDetails?.videotmsid) {
      contextData["videotmsid"] =  this.videotmsid || this._entitlementData.videotmsid || window.lcProgrammeDetails.videotmsid
    }

    if(this._entitlementData?.gist?.primaryCategory) {
      contextData["videosubcat1"] = this._entitlementData?.gist?.primaryCategory?.title
    }
    if(this._entitlementData?.categories?.length) {
      contextData["videosubcat2"] = this._entitlementData?.categories.map((cat) => cat.title).join(", ")
    }
    if(window?.epsNumber || window?.epsNumber === 0 || window.lcProgrammeDetails?.seriesDetails) {
      contextData["videoepnumber"] = window?.epsNumber || window.lcProgrammeDetails?.seriesDetails?.episode || "N/A"
    }
    if (window?.videoseason || window.lcProgrammeDetails?.seriesDetails) {
      contextData["videoseason"] = window.videoseason ||  window.lcProgrammeDetails?.seriesDetails?.season || "N/A"
    }
    return contextData
  }

  VideoAnalyticsProviderWrapper = VideoAnalyticsProvider
})();